import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-qa": "deposit-info" }
const _hoisted_2 = {
  "format-key": "0",
  "data-qa": "payment-amount"
}
const _hoisted_3 = {
  "format-key": "0",
  "data-qa": "payment-amount"
}
const _hoisted_4 = {
  "format-key": "0",
  "data-qa": "payment-amount"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_localize = _resolveComponent("localize")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isCrowdfundingProject)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          ($options.isPayType)
            ? (_openBlock(), _createBlock(_component_localize, {
                key: `${$props.paymentAmount}_${$setup.paymentInfoBoxTypes.pay}`,
                resource: _ctx.Resources.Checkout.CheckoutPledgeInstantDepositDetailsInfoLabel
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_2, _toDisplayString($props.paymentAmount), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["resource"]))
            : (_openBlock(), _createBlock(_component_localize, {
                key: `${$props.paymentAmount}_${$setup.paymentInfoBoxTypes.pledge}`,
                resource: _ctx.Resources.Checkout.CheckoutPledgeDeferredDepositDetailsInfoLabel
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_3, _toDisplayString($props.paymentAmount), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["resource"]))
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createBlock(_component_localize, {
          key: $props.orderAmount,
          resource: _ctx.Resources.Checkout.CheckoutDepositDetailsInfoLabel
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_4, _toDisplayString($props.orderAmount), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["resource"]))
  ]))
}